import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      width: '100%',
      overflowX: 'hidden',
    };

    this.sticky = {
      alignSelf: 'flex-start',
      justifySelf: 'flex-end',
      position: 'sticky',
      pt: [11, null, 0],
      top: 'calc(var(--header-height) + var(--promoBar-height) + 20px)',
      width: '100%',

      wrapper: {
        variant: 'flex.column',
      },
    };

    this.ctas = {
      variant: 'flex.column.start',
      borderTop: (t) => `1px solid ${t.colors.gray}`,
    };
  })()
);
